var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetWebCenter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Fleet_WebCenter"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fleet_WebCenter",
    "data-name": "Fleet WebCenter",
    clipPath: "url(#clip-Fleet_WebCenter)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22306",
    "data-name": "Path 22306",
    d: "M18.255,9.668a7.363,7.363,0,0,0-5.674-5.722,1.542,1.542,0,0,0-3.052,0A7.371,7.371,0,0,0,3.851,9.668a1.542,1.542,0,0,0,.032,3.068,7.379,7.379,0,0,0,5.634,5.6,1.542,1.542,0,0,0,3.076,0,7.375,7.375,0,0,0,5.634-5.6,1.542,1.542,0,0,0,.028-3.064Zm-7.2-6.435a.956.956,0,1,1-.952.952A.956.956,0,0,1,11.055,3.233ZM9.732,4.986a1.542,1.542,0,0,0,2.825-.438,6.774,6.774,0,0,1,5.008,4.781,7.128,7.128,0,0,0-3.132-1.554,8.654,8.654,0,0,0-.8-1.992.291.291,0,1,0-.506.287,8.041,8.041,0,0,1,.657,1.566,14.021,14.021,0,0,0-2.662-.247,13.579,13.579,0,0,0-2.789.287,6.152,6.152,0,0,1,1.395-2.69Zm4.554,6.264a13.037,13.037,0,0,1-.311,2.841A13.109,13.109,0,0,1,11,14.425a12.77,12.77,0,0,1-2.841-.311,12.886,12.886,0,0,1-.339-2.972A13.037,13.037,0,0,1,8.134,8.3a13.109,13.109,0,0,1,2.972-.347,12.77,12.77,0,0,1,2.841.311,12.886,12.886,0,0,1,.339,2.984ZM9.242,4.619A7.108,7.108,0,0,0,7.624,7.807a8.622,8.622,0,0,0-2.012.8A.3.3,0,0,0,5.5,9a.3.3,0,0,0,.4.112,7.614,7.614,0,0,1,1.57-.634,14.009,14.009,0,0,0-.243,2.662,13.83,13.83,0,0,0,.287,2.789A6.16,6.16,0,0,1,4.847,12.5a1.538,1.538,0,0,0-.4-2.789A6.774,6.774,0,0,1,9.242,4.619ZM3.086,11.2a.952.952,0,1,1,.28.675A.956.956,0,0,1,3.086,11.2Zm7.969,7.969a.952.952,0,1,1,.952-.952.952.952,0,0,1-.952.952Zm1.319-1.757a1.538,1.538,0,0,0-2.789.339A6.8,6.8,0,0,1,4.576,13.1a7.24,7.24,0,0,0,3.1,1.522,8.654,8.654,0,0,0,.8,1.992.3.3,0,0,0,.259.151.295.295,0,0,0,.259-.446,7.746,7.746,0,0,1-.657-1.57A13.7,13.7,0,0,0,11,15a13.858,13.858,0,0,0,2.789-.287,6.156,6.156,0,0,1-1.411,2.69Zm.634.211a7.272,7.272,0,0,0,1.478-3.044,8.623,8.623,0,0,0,1.992-.8.3.3,0,0,0,.112-.4.3.3,0,0,0-.4-.112,7.71,7.71,0,0,1-1.55.661,14.009,14.009,0,0,0,.251-2.662,13.83,13.83,0,0,0-.287-2.789,6.1,6.1,0,0,1,2.666,1.434,1.538,1.538,0,0,0,.375,2.789,6.774,6.774,0,0,1-4.638,4.913Zm5.06-5.471a.952.952,0,1,1,.956-.952.952.952,0,0,1-.956.952Z",
    transform: "translate(-2.045 -2.197)",
    fill: "#0072ce",
    stroke: "#0072cd",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetWebCenter);
export default __webpack_public_path__ + "static/media/Fleet Web Center.344459cd2df16b4ea4ea1d3b64aaad4c.svg";
export { ForwardRef as ReactComponent };